import React from 'react';
import { Paper as MuiPaper } from '@material-ui/core';

const Paper = props => <MuiPaper {...props} />;

export default Paper;
